import { GlobalAxios } from "../axios/axios-config";
import {
  IAutomationTasyOrientation,
  INewAutomationTasyOrientation,
} from "../models/automation_tasy_orientation";

const AUTOMATION_RULE_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationTasyOrientation/";

export const createAutomationTasyOrientation = (
  item: INewAutomationTasyOrientation
) => {
  return GlobalAxios.post(AUTOMATION_RULE_ROUTE, item);
};

export const getAutomationTasyOrientationById = (id: string) => {
  return GlobalAxios.get<IAutomationTasyOrientation>(
    AUTOMATION_RULE_ROUTE + id
  );
};

export const updateAutomationTasyOrientationById = ({
  item,
  id,
}: {
  item: INewAutomationTasyOrientation;
  id: string;
}) => {
  return GlobalAxios.put(AUTOMATION_RULE_ROUTE + id, item);
};
